import { useEffect, useState } from "react";
import { getBleedBalance } from "@/Api/bleeds";
import { usePermissions } from "@/hooks/usePermissions";
import { TypeUser } from "@/types/userType";

// Cache por sessão da página: a sidebar remonta em várias telas e não precisa consultar de novo
let cachedUserId: number | null = null;
let cachedValue: boolean | null = null;
let pending: Promise<boolean> | null = null;

/**
 * Para vendedores: indica se a unidade do vendedor usa sangria (null enquanto carrega).
 * Para os demais tipos de usuário retorna sempre true (a regra de unidade não se aplica).
 */
export function useSellerUsesBleed(): boolean | null {
  const { user } = usePermissions();
  const isSeller = user?.user_type_id === TypeUser.seller;
  const userId = user?.id ?? null;

  const [usesBleed, setUsesBleed] = useState<boolean | null>(
    isSeller && cachedUserId === userId ? cachedValue : null
  );

  useEffect(() => {
    if (!isSeller || !userId) return;

    if (cachedUserId === userId && cachedValue !== null) {
      setUsesBleed(cachedValue);
      return;
    }

    if (cachedUserId !== userId || !pending) {
      cachedUserId = userId;
      cachedValue = null;
      pending = getBleedBalance()
        .then(({ data, ok }) => (ok ? !!data?.response?.has_bleed : false))
        .catch(() => false)
        .then((value) => {
          cachedValue = value;
          return value;
        });
    }

    let active = true;
    pending.then((value) => active && setUsesBleed(value));
    return () => {
      active = false;
    };
  }, [isSeller, userId]);

  if (!user) return null;
  return isSeller ? usesBleed : true;
}
